import Vue from 'vue';
import Mousetrap from 'mousetrap';

Vue.directive('key-combo', {
  bind: (el, binding, vnode) => {
    Mousetrap.bind(binding.value, () => {
      vnode.context.$emit('keycombo::success');
    });
  },
});



// WEBPACK FOOTER //
// ./src/directives/key-combo.js